module.exports = __webpack_public_path__ + "static/media/wheel-balancing.15e41686.svg";